import { MenuItemProps, SubMenuItemProps } from '../containers/types';
import { UserRolesEnum } from '../enums/user-roles.enum';

export const menuOptions = [
  {
    id: 1,
    icon: 'dashboard',
    alias: 'DASHBOARD',
    name: 'DASHBOARD',
    text: 'Dashboard',
    title: 'Dashboard',
    route: 'dashboard'
  },
  {
    id: 2,
    icon: 'fire extinguisher',
    alias: 'FIRE',
    name: 'ANALYSIS',
    text: 'Incêndio',
    submenuItems: [
      {
        id: 1,
        name: 'fire-insurance-budget',
        route: 'fire-insurance-budget',
        text: 'Novo Orçamento',
        title: 'Novo Orçamento',
        parentAlias: 'FIRE'
      },
      {
        id: 2,
        name: 'fire-insurance-budgets',
        route: 'fire-insurance-budgets',
        text: 'Gerenciar Orçamentos',
        title: 'Gerenciar Orçamentos',
        parentAlias: 'FIRE'
      },
      {
        id: 3,
        name: 'fire-insurance-policies',
        route: 'fire-insurance-policies',
        text: 'Gerenciar Apólices',
        title: 'Gerenciar Apólices',
        parentAlias: 'FIRE'
      },
      {
        id: 4,
        name: 'fire-insurance-invoices',
        route: 'fire-insurance-invoices',
        text: 'Faturas',
        title: 'Faturas',
        parentAlias: 'FIRE'
      }
      // {
      //   id: 5,
      //   name: 'fire-insurance-batches',
      //   route: 'fire-insurance-batches',
      //   text: 'Lotes',
      //   title: 'Lotes - Yelum',
      //   parentAlias: 'FIRE',
      //   requiresRole: UserRolesEnum.brokerAdmin
      // }
    ]
  },
  {
    id: 3,
    icon: 'shield',
    alias: 'BOND',
    name: 'ANALYSIS',
    text: 'Fiança',
    submenuItems: [
      {
        id: 1,
        name: 'find-record',
        route: 'find-record',
        text: 'Localizar Registro',
        title: 'Localizar Registro',
        parentAlias: 'BOND'
      },
      {
        id: 2,
        name: 'bond-insurance',
        route: 'bond-insurance',
        text: 'Nova Análise',
        title: 'Nova Análise',
        parentAlias: 'BOND'
      },
      {
        id: 3,
        name: 'bond-insurances',
        route: 'bond-insurances',
        text: 'Gerenciar Análises',
        title: 'Gerenciar Análises',
        parentAlias: 'BOND'
      },
      {
        id: 4,
        name: 'bond-insurance-proposals',
        route: 'bond-insurance-proposals',
        text: 'Gerenciar Propostas',
        title: 'Gerenciar Propostas',
        parentAlias: 'BOND'
      },
      {
        id: 5,
        name: 'bond-insurance-policies',
        route: 'bond-insurance-policies',
        text: 'Gerenciar Apólices',
        title: 'Gerenciar Apólices',
        parentAlias: 'BOND'
      },
      {
        id: 6,
        name: 'canceled-bond-insurances',
        route: 'canceled-bond-insurances',
        text: 'Gerenciar Canceladas',
        title: 'Gerenciar Canceladas',
        parentAlias: 'BOND'
      },
      {
        id: 7,
        name: 'expired-bond-insurances',
        route: 'expired-bond-insurances',
        text: 'Gerenciar Expirados',
        title: 'Gerenciar Expirados',
        parentAlias: 'BOND'
      },
      {
        id: 8,
        name: 'reports-form',
        route: 'reports-form',
        text: 'Relatórios',
        title: 'Relatórios',
        parentAlias: 'BOND'
      }
    ]
  },
  {
    id: 4,
    icon: 'lock',
    alias: 'CAPITALIZATION',
    name: 'ANALYSIS',
    text: 'Capitalização',
    submenuItems: [
      {
        id: 1,
        name: 'capitalizations',
        route: 'capitalizations',
        text: 'Gerenciar Capitalizações',
        title: 'Gerenciar Capitalizações',
        parentAlias: 'CAPITALIZATION'
      }
    ]
  },
  {
    id: 10,
    icon: 'dollar',
    alias: 'LENDER_INSURANCE',
    name: 'LENDER_INSURANCE',
    text: 'Prestamista',
    submenuItems: [
      {
        id: 1,
        name: 'lender-insurances',
        route: 'lender-insurances',
        text: 'Gerenciar Prestamistas',
        title: 'Gerenciar Seguros Prestamistas',
        parentAlias: 'LENDER_INSURANCE'
      },
      {
        id: 2,
        name: 'lender-insurance-batches',
        route: 'lender-insurance-batches',
        text: 'Lotes Mensais',
        title: 'Gerenciar Lotes Mensais',
        parentAlias: 'LENDER_INSURANCE'
      }
    ]
  },
  {
    id: 5,
    icon: 'fire',
    alias: 'CLAIMS',
    name: 'CLAIMS',
    text: 'Sinistros',
    submenuItems: [
      {
        id: 1,
        name: 'claim-estates',
        route: 'claim_estates',
        text: 'Sinistros ativos',
        title: 'Sinistros Ativos',
        parentAlias: 'CLAIMS'
      },
      {
        id: 2,
        name: 'claim-estate-responsible-transfer',
        route: 'claim-estate-responsible-transfer',
        text: 'Gerenciar responsáveis',
        title: 'Gerenciar Responsáveis',
        parentAlias: 'CLAIMS'
      }
    ]
  },
  {
    id: 6,
    icon: 'home',
    alias: 'ESTATES',
    name: 'ESTATES',
    text: 'Imobiliárias',
    submenuItems: [
      {
        id: 1,
        name: 'warehouse[estate]',
        route: 'estate',
        text: 'Nova Imobiliária',
        title: 'Nova Imobiliária',
        parentAlias: 'ESTATES'
      },
      {
        id: 2,
        name: 'warehouse[estates]',
        route: 'estates',
        text: 'Imobiliárias',
        title: 'Imobiliárias',
        parentAlias: 'ESTATES'
      },
      {
        id: 3,
        name: 'warehouse[estates-preregister]',
        route: 'estates-preregister/new',
        text: 'Novo Pré-cadastro',
        title: 'Novo Pré-cadastro',
        parentAlias: 'ESTATES'
      },
      {
        id: 4,
        name: 'warehouse[estates-preregister-form]',
        route: 'estates-preregisters',
        text: 'Pré-cadastros',
        title: 'Pré-cadastros',
        parentAlias: 'ESTATES'
      }
    ]
  },
  {
    id: 7,
    icon: 'users',
    alias: 'USERS',
    name: 'USERS',
    text: 'Usuários',
    submenuItems: [
      {
        id: 1,
        name: 'new-user',
        route: 'user',
        text: 'Novo Usuário',
        title: 'Novo Usuário',
        parentAlias: 'USERS'
      },
      {
        id: 2,
        name: 'list-users',
        route: 'users',
        text: 'Usuários',
        title: 'Usuários',
        parentAlias: 'USERS'
      }
    ]
  },
  {
    id: 8,
    icon: 'handshake outline',
    alias: 'FRANCHISES',
    name: 'FRANCHISES',
    text: 'Franqueados',
    submenuItems: [
      {
        id: 1,
        name: 'new-franchise',
        route: 'franchise/new',
        text: 'Novo Franqueado',
        title: 'Novo Franqueado',
        parentAlias: 'FRANCHISES'
      },
      {
        id: 2,
        name: 'list-franchises',
        route: 'franchises',
        text: 'Gerenciar Franqueados',
        title: 'Gerenciar Franqueados',
        parentAlias: 'FRANCHISES'
      },
      {
        id: 3,
        name: 'list-master-franchises',
        route: 'master-franchises',
        text: 'Gerenciar Multi Franquias',
        title: 'Gerenciar Multi Franquias',
        parentAlias: 'MASTER-FRANCHISES'
      },
      {
        id: 4,
        name: 'franchises-dashboard',
        route: 'franchises-dashboard',
        text: 'Análise de Desempenho',
        title: 'Análise de Desempenho',
        parentAlias: 'FRANCHISES'
      }
    ]
  },
  {
    id: 9,
    icon: 'setting',
    alias: 'MANAGEMENT',
    name: 'MANAGEMENT',
    text: 'Administração',
    submenuItems: [
      {
        id: 1,
        name: 'BANNERS',
        route: 'banner-management',
        text: 'Gerenciar Banners',
        title: 'Banners',
        parentAlias: 'MANAGEMENT'
      },
      {
        id: 2,
        name: 'BLACKLIST',
        route: 'blacklist',
        text: 'Blacklist',
        title: 'Blacklist',
        parentAlias: 'MANAGEMENT'
      },
      {
        id: 3,
        name: 'LOGS',
        route: 'logs',
        text: 'Logs',
        title: 'Logs',
        parentAlias: 'MANAGEMENT'
      },
      {
        id: 4,
        name: 'REPORTS',
        route: 'reports',
        text: 'Relatórios',
        title: 'Relatórios'
      },
      {
        id: 5,
        name: 'NOTIFICATIONS',
        route: 'notifications',
        text: 'Notificações',
        title: 'Notificações',
        parentAlias: 'NOTIFICATIONS'
      },
      // {
      //   id: 6,
      //   name: 'POWERBI',
      //   route: 'powerbi',
      //   text: 'Power BI',
      //   title: 'Power BI',
      //   parentAlias: 'MANAGEMENT'
      // },
      {
        id: 7,
        name: 'FINANCEIRO',
        route: 'financial',
        text: 'Financeiro',
        title: 'Financeiro',
        parentAlias: 'MANAGEMENT'
      },
      {
        id: 8,
        name: 'INTEGRATIONS',
        route: 'integrations-dashboard',
        text: 'Integrações',
        title: 'Integrações',
        parentAlias: 'INTEGRATIONS'
      },
      {
        id: 9,
        name: 'STANDALONE_CHARGES',
        route: 'standalone-charges',
        text: 'Cobranças',
        title: 'Cobranças',
        parentAlias: 'MANAGEMENT'
      }
    ]
  }
];

export const getMenuPageInfo = (name: string): MenuItemProps | SubMenuItemProps => {
  const pageFromMainMenu = menuOptions.find(opt => opt.name === name);

  if (pageFromMainMenu) return { ...pageFromMainMenu };

  const pageFromSubMenu = menuOptions
    .flatMap(opt => opt.submenuItems || [])
    .find(item => item.name === name);

  return pageFromSubMenu
    ? { ...pageFromSubMenu }
    : {
      id: 1,
      alias: 'DASHBOARD',
      name: 'DASHBOARD',
      text: 'Dashboard',
      title: 'Dashboard',
      route: 'dashboard'
    };
};
